
$_GP.globalCall = (function() {

	// const $doc    = $(document)
	const $window = $(window)
	const body   = $('body')

	const twbsCalls = function() {
		const dropdownMenu = $('ul.dropdown-menu [data-toggle=dropdown]');
		dropdownMenu.on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			dropdownMenu.parent().removeClass('open');
			$(this).parent().addClass('open');
		});
	}

	const editorIframeYT = function() {
		const ytIframe16by9 = $('.content-editable iframe[src*="www.youtube.com"]:not(.content-editable .embed-responsive-16by9 iframe[src*="www.youtube.com"])');

		if (ytIframe16by9.length > 0) {
			ytIframe16by9.attr('allowfullscreen', '')
				.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
		}
	}

	const headerFixed = function() {

		let FIXED = false;

		const fixed = function() {
			const distTop = $window.scrollTop();

			if (!FIXED && distTop > 50) {
				body.addClass('header-fixed');
				FIXED = true;
			}

			if (FIXED && distTop <= 50 ) {
				body.removeClass('header-fixed');
				FIXED = false;
			}
		};

		fixed();

		$window.scroll($_GP._.throttle(fixed));
	}

	const navbarToggle = function() {
		const header   = $('#header');
		const triggers = header.find('[data-ev="btnNavbarToggle"]');
		let isOpen = false;

		triggers.on('click', ()=> {
			isOpen = !isOpen
			body.toggleClass('header-navbar-is-open',isOpen)
			triggers.attr('aria-expanded', isOpen);
		})
	}

	const cookieWarning = function() {
		$(function() {
			const warning       = $('#browser-cookie-warning');
			const btn           = warning.find('button');
			const warningClosed = Cookies.get('gpb_cookieWarningClosed');

			if (!warningClosed) warning.addClass('show');

			btn.on('click', ()=> Cookies.set('gpb_cookieWarningClosed', 'true', { expires: 365 }));
		});
	}

	const clickScroll = function() {
		const btn = $('[data-node="scrollView"]');
		const scroll = function() {
			const headerHeight = $('.header-bottom').outerHeight()
			const barHeight = $(this).closest('.titles-bar-top').outerHeight()
			const dist = window.innerHeight - (barHeight + headerHeight)
			$('html,body').stop().animate({scrollTop: dist})
		}
		btn.on('click', scroll)
	}

	const countCharacters = function() {
		const trigger = $('[data-node-counter="trigger"]');

		trigger.on('keyup blur focus', function() {
			const _this = $(this)
			const len = _this.val().length
			_this.closest('[data-node="counter"]').find('[data-node-counter="target"]').text(len)
		});
	}

	cookieWarning()
	editorIframeYT()
	headerFixed()
	twbsCalls()
	navbarToggle()
	clickScroll()
	countCharacters()
}());
